import Game from '../components/game';
import Header from '../components/layouts/header';
import LotteryCard from '../components/lotteryCard';
import Results from '../components/results';
import Testimonios from '../components/testimonios';
import Winner from '../components/winner';
import WinnerTwo from '../components/winnerTwo';
import CountdownTimer from '../components/elements/countdownTimer';
import React, { useEffect } from 'react';
import './css/home.scss';
import AboutCarou from '../components/elements/aboutCarou';
import cents1 from '../assets/images/cents1.webp';
import cents2 from '../assets/images/cents2.webp';
import cents3 from '../assets/images/cents3.webp';
import cents4 from '../assets/images/cents4.webp';
import GameTwo from '../components/gameTwo';
import Navbar from '../components/layouts/navbar';
import Footer from '../components/layouts/footer';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '../components/css/lotteryCard.scss';
import watsap from '../assets/images/watsap.png';
import facebook from '../assets/images/facebook.jpg';
import instagram from '../assets/images/instagram.png';
import twitter from '../assets/images/twitter.png';
import youtube from '../assets/images/youtube.png';
import { useState } from 'react';
import apiDraw from '../api/draw';
import { sportDrawActive } from '../api/sportDraw';
import { navigate } from '@reach/router';
import { Link } from 'react-scroll';
import zIndex from '@material-ui/core/styles/zIndex';
import { Helmet } from 'react-helmet';
import { useEmailValidation } from '../hooks/isEmailValid';
import WinnerImg from '../assets/images/winner.jpeg';
import { loginApi, gamesApi, serialsApi, generateSerialsApi } from '../api/auth';
import { KEYUTIL, KJUR } from 'jsrsasign'; // Importa jsrsasign

function Home() {
  const THREE_DAYS_IN_MS = 14 * 23 * 60 * 60 * 1000;
  const NOW_IN_MS = new Date().getTime();
  const [date, setDate] = useState();
  const [sportDraws, setSportDraws] = useState([]);

  const isEmailValid = useEmailValidation();

  const getSportDrawAction = async () => {
    const online = true;
    sportDrawActive(online, isEmailValid).then((res) => {
      setSportDraws(res.data);
    });
  };


  useEffect(() => {
    const fetchData = async () => {
      const data = await apiDraw.fetchDrawActive();
      setDate(new Date(data.data.endDate.split('.')[0]));
    };

    fetchData();
    getSportDrawAction();
  }, []);

  useEffect(() => {
    getSportDrawAction();
  }, [isEmailValid]);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     getSportDrawAction();
  //   }, 10000);

  //   return () => clearInterval(interval);
  // });

  return (
    <>
      <Helmet>
        <title>LottoQuiz</title>
      </Helmet>
      <div id="main" className="main">
        <Navbar />
        {/* <div class="container">
          <h4 className="text-follow text-center">¡Síguenos!</h4>
        </div> */}
        <div className="cotainer justify-content-center d-flex bg-networks mt-5">
          <a
            target="_blank"
            className="watsapp"
            href="https://wa.me/584247336043"
          >
            <img src={watsap} className="watsappimg" />
          </a>
          <a
            target="_blank"
            className="facebook"
            href="https://www.facebook.com/profile.php?id=100090370083338&mibextid=LQQJ4d"
          >
            <img src={facebook} className="facebookimg" />
          </a>
          <a
            target="_blank"
            className="instagram"
            href="https://instagram.com/lottoquiz.vzla?igshid=MzRlODBiNWFlZA=="
          >
            <img src={instagram} className="instagramimg" />
          </a>
          <a
            target="_blank"
            className="twitter"
            href="https://twitter.com/lottoquizvzla"
          >
            <img src={twitter} className="twitterimg" />
          </a>
          <a
            target="_blank"
            className="youtube"
            href="https://youtube.com/@lottoquiz"
          >
            <img src={youtube} className="youtubeimg" />
          </a>
        </div>

        <div className="home">
          <div className="container-header" id="header">
            <Header />
          </div>

          <div
            className="content mb-2 mt-drawSport mb-drawSport relative"
            style={{ zIndex: 1000 }}
          >
            <div className="count-days" id="draw">
              <img src={cents1} alt="cent" className="coin-1" />
              <img src={cents2} alt="cent" className="coin-2" />
              <img src={cents3} alt="cent" className="coin-3" />
              <img src={cents4} alt="cent" className="coin-4" />
              <h3>Serial Beisbol en línea</h3>

              {sportDraws && sportDraws.length !== 0 ? (
                <>
                  <div className="d-flex justify-content-center">
                    <table className="table-drawSport w-75">
                      <thead className="table-drawSport">
                        <tr>
                          <th>Juego</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {sportDraws.map((data, index) => {
                          const percentage =
                            data.sportDraw?.percentage === undefined
                              ? 0
                              : parseInt(data.sportDraw?.percentage);
                          const totalValue =
                            (data.totalTickets *
                              (data.sportDraw.valor * percentage)) /
                            100;
                          const showValue =
                            totalValue < 100
                              ? 'En proceso'
                              : `$${parseFloat(totalValue).toFixed(2)}`;
                          const showWinner = data.sportDraw.winning_serial;
                          const _id = data.sportDraw._id;

                          return (
                            <tr key={index}>
                              <td>{data.sportDraw.description}</td>
                              {data.sportDraw.status !== 'Deshabilitado' && (
                                <td>
                                  <a className="btn btn-sm btn-primary"
                                    href='https://compras.sellatuserial.com/landing'
                                  >
                                      Jugar
                                  </a>
                                </td>
                              )}
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </>
              ) : (
                <div className="d-flex justify-content-center">
                  <p>No hay sorteos disponibles</p>
                </div>
              )}
            </div>
          </div>

          {/* <div className="d-flex justify-content-center mt-5 mb-5">
            <div className="w-50 d-none d-lg-block">
              <img
                src={WinnerImg}
                alt="winner"
                className="img-fluid mt-3 mb-2"
              />
            </div>
            <div className="w-75 d-lg-none">
              <img
                src={WinnerImg}
                alt="winner"
                className="img-fluid mt-3 mb-2"
              />
            </div>
          </div> */}

          <div className="content mt-drawSport">
            <div className="count-days" id="draw">
              <img src={cents1} alt="cent" className="coin-1" />
              <img src={cents2} alt="cent" className="coin-2" />
              <img src={cents3} alt="cent" className="coin-3" />
              <img src={cents4} alt="cent" className="coin-4" />
              <h3>EL SORTEO SE REALIZA EN:</h3>

              {date && <CountdownTimer targetDate={date} />}
            </div>

            {/* <div className="lottery">
              <LotteryCard />
            </div> */}

            <div id="result">
              <Results />
            </div>

            <div className="responsive" id="easy">
              <div className="easy-items">
                {/* <Game /> */}
                {/* <Winner /> */}
                {/*<GameTwo />*/}
              </div>
              {/*<div className="easy-items-two">
            <div id="winner">
              <Winner />
            </div>
            <div id="winnerTo">
              <WinnerTwo />
            </div>
          </div>*/}
            </div>
            {/*<div className="test" id="testimonials">
          <Testimonios />
        </div>*/}
            {/* <div className="about" id="lottoquiz">
              <div className="about-text">
                <h1 className="lottoquiz">LottoQuiz en Venezuela</h1>
                <p className="about-us">LottoQuiz en las calles de Venezuela</p>
              </div>
              <div className="video">
                <AboutCarou />
              </div>
            </div> */}
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}

export default Home;
